import apiClient from '../client/api';

export type GetInviteCodeResponse = boolean;

async function checkInviteCode(inviteCode: string): Promise<GetInviteCodeResponse> {
  const response = await apiClient.get(`/invite-code/${inviteCode}`);

  return response.data;
}

export default { checkInviteCode };
